const FETCH_NOTIFICATIONS = 'notifications/FETCH_NOTIFICATIONS';

const RESET = 'notifications/RESET';

export default {
  FETCH_NOTIFICATIONS,
  RESET,
};



// WEBPACK FOOTER //
// ./src/app/redux/front/notifications/types.js